app.service('stringHelper', [function () {
  var stringHelperService = this;

  stringHelperService.isNullOrEmpty = function (value) {
    return (value === '' || value === null || value === undefined);
  };

  stringHelperService.isHtmlEmpty = function (value) {
    if (stringHelperService.isNullOrEmpty(value)) return true;
    let text = value.replaceAll(/<[^>]{0,500}>/g, '').replaceAll('&nbsp;', ' ').trim();
    return text.length === 0;
  };
}]);
